export const formatCount = (count?: number) => {
  if (typeof count !== "number") return "0";
  if (count >= 1_000_000)
    return (count / 1_000_000).toFixed(count % 1_000_000 === 0 ? 0 : 1) + "M";
  if (count >= 1_000)
    return (count / 1_000).toFixed(count % 1_000 === 0 ? 0 : 1) + "K";
  return count.toString();
};
